// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import axios from 'axios'
import ElementUI from 'element-ui'
import locale from 'element-ui/lib/locale'
import 'element-ui/lib/theme-chalk/index.css'
import VueI18n from 'vue-i18n';

window.Vue = Vue;

Vue.config.productionTip = false
Vue.use(VueI18n);
Vue.use(ElementUI)

console.log(window.location,window.location.hash.split("?")[1])

const i18n = new VueI18n({
	locale: 'zh-CN',
	messages:{
		'zh-CN':require('./common/lang/zh').default,
		'en-US':require('./common/lang/en').default
	}
});
locale.i18n((key, value) => i18n.t(key, value)); 

Vue.prototype.$axios = axios
/* eslint-disable no-new */
new Vue({
  el: '#app',
  i18n,
  router,
  components: { App },
  template: '<App/>',
  store
})



// WEBPACK FOOTER //
// ./src/main.js